import { createAsyncThunk } from '@reduxjs/toolkit';
import Api, { ApiResponse, FetchParams } from '../utils/Api';
import {
  getOrderingProvider,
  getShowExpiredCoupons,
} from '../selectors/config';
import { getLocationId, getMember } from '../selectors';
import { getLocations } from '../selectors';
import { ORDERING_PROVIDER } from '../constants/orderingProvider';
import processOffer from '../utils/processors/processOffer';
import { addOffers } from '../reducers/currentOrder/offers';

export const fetchLocationOffers = createAsyncThunk(
  'fetchLocationOffers',
  async (data: undefined, { dispatch, getState, rejectWithValue }) => {
    try {
      const orderingProvider = getOrderingProvider(
        getState() as EntireFrontendState,
      );
      const member = getMember(getState() as EntireFrontendState);
      const locations = getLocations(getState() as EntireFrontendState);
      const locationId = getLocationId(getState() as EntireFrontendState);

      const authenticationMethod =
        orderingProvider === ORDERING_PROVIDER.KIOSK ? 'trusted' : 'member';

      const showExpiredCoupons = getShowExpiredCoupons(
        getState() as EntireFrontendState,
      );

      // For non-kiosk ordering providers we must pass the store ID.
      // The API only includes "AvailableAtLocation" and "AvailableAtTime" in its response if a store ID is provided.
      // These fields are required for our offer filtering logic — without them, the offer would be marked invalid.

      // TODO: Consider refactoring our multiple offer-fetching thunks
      // (e.g., fetchLocationOffers, fetchOffers, fetchMemberOffers) into one.
      // Having too many separate thunks makes the logic harder to maintain.

      let kioskPath = `/api/v1/stores/${
        locations![Object.keys(locations!)[0]].id
      }/trusted-pospoints/coupons/${member?.memberNumber}`;

      let nonKioskPath = `/api/v1/profile/coupons?hideexpired=${
        showExpiredCoupons ? '0' : '1'
      }`;

      if (locationId) {
        nonKioskPath += `&storeid=${locationId}`;
      }

      const path =
        orderingProvider === ORDERING_PROVIDER.KIOSK ? kioskPath : nonKioskPath;

      const params: FetchParams = {
        path,
        method: 'GET',
      };

      const response: ApiResponse = await Api.fetch(
        params,
        authenticationMethod,
      );

      dispatch(addOffers((response.data as RawOffer[]).map(processOffer)));
    } catch (e) {
      console.warn('Fetch member offers failed');
      return rejectWithValue(e);
    }
  },
);
